import { Http } from '@angular/http';
import { Injectable, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from './../../environments/environment';
const { Manager } = require("socket.io-client");
import { Socket } from './../shared/interfaces';
import { Howl } from 'howler';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UtilsService } from './../_services/utils.service';

declare var io: {
  connect(url: string): Socket;
};

@Injectable({
  providedIn: 'root'
})

export class ResultboardService {
  socket: Socket;
  draftSocket: any;
  chatSocket: Socket;
  observer: Observer<number>;
  draftObserver: Observer<any>;
  activeDraftObserver: Observer<any>;
  activeDraftDataObserver: Observer<any>;
  draftButtonObserver: Observer<any>;
  readyMemberObserver: Observer<any>;
  pickerTimeObserver: Observer<any>;
  initDataObserver: Observer<any>;
  pickedPlayerObserver: Observer<any>;
  activeDraftPickObserver: Observer<any>;
  draftCompleteObserver: Observer<any>;
  updateLeagueMemberObserver: Observer<any>;
  updateTournamentMemberObserver: Observer<any>;
  messageObserver: Observer<any>;
  draftMessageObserver: Observer<any>;
  draftResetCounterObserver: Observer<any>;
  activePickChangesObserver: Observer<any>;
  autodraftfalseEmitObserver: Observer<any>;
  draftPausedMessageObserver: Observer<any>;
  draftResumeMessageObserver: Observer<any>;
  saveDraftRankObserver: Observer<any>;
  destroyDraftObserver: Observer<any>;
  restart_msgObserver: Observer<any>;
  notificationReqObserver: Observer<any>;
  notificationDataObserver: Observer<any>;
  draftActiveReqObserver: Observer<any>;
  draftActiveOnObserver: Observer<any>;
  disconnectObserver: Observer<any>;
  getMessagesObserver: Observer<any>;
  displayMessagesObserver: Observer<any>;
  showMessagesObserver: Observer<any>;
  receiveMessageObserver: Observer<any>;
  friendInviteNotiObserver: Observer<any>;
  friendMsgInviteNotiObserver: Observer<any>;
  updateReqCountObserver: Observer<any>;
  addActiveUserObserver: Observer<any>;
  getNotificationObserver: Observer<any>;
  displyNotificationsObserver: Observer<any>;
  displyContactsObserver: Observer<any>;
  priorChatObserver: Observer<any>;
  receiveMsgObserver: Observer<any>;
  receiveUserTypingObserver: Observer<any>;
  deactiveUserObserver: Observer<any>;
  receiveActiveUserObserver: Observer<any>;
  receiveNewChatUserObserver: Observer<any>;
  draftPauseOrRestart = new EventEmitter();
  emitAutoDraftObserver: Observer<any>;
  // New Draft Observers

  pickTimeO: Observer<any>; // pickTime()
  pickedPlayerO: Observer<any>; // pickedPlayer()
  draftCompletedO: Observer<any>; // draftCompleted()
  showDraftO: Observer<any>; // showDraftStatus()
  draftResetO: Observer<any>; // draftReset()
  leaguePostO: Observer<any>; // leaguePost() -- This was made for badge updating even though it'll also be used in chat component
  pausedMessageO: Observer<any>; // pausedMessage()
  resumeMessageO: Observer<any>; // resumeMessage()
  pickChangesO: Observer<any>; // pickChanges()
  readyBoxO: Observer<any>; // readybox()
  listActiveDraftO: Observer<any>; // listActiveDraft()
  //callDraftSocket(user_id, league_id) -- I think call whenever switching to a draft
  @Output() newMsgReceive = new EventEmitter<any>();
  @Output() activeDraftVisible = new EventEmitter<any>();
  
  
  // End New Draft Observers
  currentUser: any;
  postMessageData: object;
  reconnectCount = 0;
  time1 = (new Date()).getTime();
  
  constructor(private _http: Http, private http: HttpClient, private _utilsService: UtilsService) {
    const currentUserDeatail = JSON.parse(localStorage.getItem('currentUser'));
    const jwt = currentUserDeatail && currentUserDeatail.token ? currentUserDeatail.token : "";
    if (!this.draftSocket) {
      const draftSocketManager = new Manager(`${environment.draftUrl}`, {
        transports: ['websocket'],
        query: { token: jwt }
      });
      this.draftSocket = draftSocketManager.socket("/"); 
    }
    
    if (!this.chatSocket) {
      const chatSocketManager = new Manager(`${environment.chatUrl}`, {
        transports: ['websocket'],
        query: { token: jwt }
      });
      this.chatSocket = chatSocketManager.socket("/"); 
    }
    this.draftSocket.on('error', (reason) => {
      // console.error(reason);
      // this.errorLog(reason).subscribe();
      // setTimeout(() => {
      //   location.reload();
      // }, 500);
      // try again forever
      setTimeout(() => {
        this.reconnectCount++;
        if (this.reconnectCount > 30) {
          window.location.reload();
        } else {
          // console.log('retrying socket connection');
          this.draftSocket.connect();
        }
      }, 1000);
    });
    this.draftSocket.on('connect', () => {
      let time2 = (new Date()).getTime();
      console.log('socket connected ', time2-this.time1);
      this.reconnectCount = 0;
    });
    this.draftSocket.on('disconnect', (res) => {
      let time2 = (new Date()).getTime();
      console.log('socket disconnected', res, time2-this.time1);
      this.draftSocket.connect();
    });
    
    this.draftSocket.on('conn_pong', res => {
      let time2 = (new Date()).getTime();
      console.log('conn_pong',time2-this.time1);
    });
    
    // setInterval(() => {
    //   this.ping2();
    // }, 20000);
    
  }

  errorLog(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user/angular-error-log', data);
  }

  getRosterPosition(league_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/fantasyLeague/get-roster-position/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + league_id);
  }

  getRankingSets(game_id, egs, lgs, user_id, league_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/league/get-ranked_games/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + game_id + '/' + egs + '/' + lgs + '/' + user_id + '/' + league_id);
  }

  importRankings(league_id, league_member_id, common_rank_id, user_id) {
    return this._utilsService.postRequest(`${environment.phpApiUrl}/league/import_rankings`, {
      league_id,
      league_member_id,
      common_rank_id,
      user_id
    });
  }

  getScoring(league_id, game_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/fantasyLeague/get-scoring-groupwise/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + league_id + '/' + game_id);
  }

  getQuotes(): Observable<number> {
    this.draftSocket.on('data', (res) => {
      this.observer.next(res.data);
    });
    return this.createObservable();
  }

  enableManualAutoPick(league_id, lgm_id) {
    this.draftSocket.emit('enableMAutoPick', { league_id, lgm_id });
  }

  disableAutoPick(league_id, lgm_id) {
    this.draftSocket.emit('disableMAutoPick', { league_id, lgm_id });
  }

  ping() {
    this.draftSocket.emit('p_time', {});
  }

  pong() {
    let localObserver;
    this.draftSocket.on('p_res', res => {
      localObserver.next(res);
    });
    return new Observable<any>(obj => {
      localObserver = obj;
    });
  }
  
  ping2() {
    this.draftSocket.emit('conn_ping', {});
  }
  
  refreshPage() {
    let localObserver;
    this.draftSocket.on('refresh_page', res => {
      localObserver.next(res);
    });
    return new Observable<any>(obj => {
      localObserver = obj;
    });
  }

  postManage(draftpost, league_id): Observable<any> {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.postMessageData = { 'userID': this.currentUser.id, 'message': draftpost, 'display_name': this.currentUser.drafters_id, 'league_uuid': league_id };
      this.draftSocket.emit('post_draft_messages', this.postMessageData);
    }
    return this.createObservable();
  }

  destroyDraftSocket(league_id): Observable<any> {
    this.draftSocket.emit('draft_destroy', league_id);
    return new Observable<any>(destroyDraftObserver => {
      this.destroyDraftObserver = destroyDraftObserver;
    });
  }

  callDraftSocket(user_id, league_id): Observable<any> {
    const userRoom = { 'user_id': user_id, 'league_id': league_id };
    this.draftSocket.emit('resultboard_init', userRoom);
    return this.createDraftObservable();
  }

  callDraftApp(user_id, league_id) {
    const userRoom = { user_id, league_id, is_app: '1' };
    this.draftSocket.emit('app_init', userRoom);
  }

  draftAppListener(): Observable<any> {
    let localObserver;
    this.draftSocket.on('init_draft_data', res => {
      localObserver.next(res);
    });
    return new Observable<any>(obj => {
      localObserver = obj;
    });
  }

  emitAutoDraft(user_id, league_id): Observable<any> {
    const userRoom = { 'user_id': user_id, 'league_id': league_id };
    this.draftSocket.emit('enable_autopick_mode', userRoom);
    return new Observable<any>(emitAutoDraftObserver => {
      this.emitAutoDraftObserver = emitAutoDraftObserver;
    });
  }

  // disconnect(): Observable<any> {
  //   let localObserver;
  //   this.draftSocket.on('disconnect', (res) => {
  //     // window.location.reload();
  //     localObserver.next(res);
  //   });
  //   return new Observable<any>(disconnectObserver => {
  //     localObserver = disconnectObserver;
  //   });
  // }

  predraft() {
    this.draftSocket.on('predraft', (res) => {
      this.draftObserver.next(res);
    });

    return this.createAnyObservable();
  }

  readybox(): Observable<any> {
    let localObserver;
    this.draftSocket.on('ready_box', res => {
      localObserver.next(res);
    });

    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }

  disconnectEvent(): Observable<any> {
    let localObserver;
    this.draftSocket.on('disconnect', res => {
      localObserver.next(res);
    });

    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }
  
  
  connectEvent(): Observable<any> {
    let localObserver;
    this.draftSocket.on('connect', res => {
      localObserver.next(res);
    });

    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }

  listActiveDraft(): Observable<any> {
    let localObserver;
    this.draftSocket.on('list_active_draft', res => {
      localObserver.next(res);
    });

    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }

  total_ready_member() {
    this.draftSocket.on('total_ready_member', (res) => {
      this.readyMemberObserver.next(res);
    });

    return new Observable<any>(readyMemberObserver => {
      this.readyMemberObserver = readyMemberObserver;
    });
  }

  pickerTime(): Observable<any> {
    this.draftSocket.on('pick_timer', (res) => {
      this.pickerTimeObserver.next(res);
    });

    return this.createPickerTimeObservable();
  }

  pickTime(): Observable<any> {
    this.draftSocket.on('pick_timer', res => {
      this.pickTimeO.next(res);
    });
    return new Observable<any>(obs => {
      this.pickTimeO = obs;
    });
  }

  init_data(): Observable<any> {
    this.draftSocket.on('init_data', (res) => {
      this.initDataObserver.next(res);
    });
    return this.createinitDataObservable();
  }

  picked_player() {
    this.draftSocket.on('picked_player', (res) => {
      this.pickedPlayerObserver.next(res);
    });

    return new Observable<any>(pickedPlayerObserver => {
      this.pickedPlayerObserver = pickedPlayerObserver;
    });
  }

  pickedPlayer() {
    let localObservable;
    this.draftSocket.on('picked_player', res => {
      localObservable.next(res);
    });
    return new Observable<any>(obs => {
      localObservable = obs;
    });
  }

  draft_complete() {
    this.draftSocket.on('draft_complete', (res) => {
      this.draftCompleteObserver.next(res);
    });

    return new Observable<any>(draftCompleteObserver => {
      this.draftCompleteObserver = draftCompleteObserver;
    });
  }

  draftCompleted() {
    this.draftSocket.on('draft_complete', res => {
      this.draftCompletedO.next(res);
    });

    return new Observable<any>(obs => {
      this.draftCompletedO = obs;
    });
  }

  iAmReadyForJoinLeague(data) {
    this.draftSocket.emit('i_am_ready', data);
    return this.createObservable();
    // data => {user_id, league_id, entrants}
  }

  imReady(league_id, user_id, entrants) {
    this.draftSocket.emit('i_am_ready', {
      league_id,
      user_id,
      entrants
    });
  }

  leaveRoom(league_id) {
    this.draftSocket.emit('destroy_lg_socket', {
      league_id
    });
  }

  autodraftfalseEmit(user_id, league_id): Observable<any> {
    const userData = { 'user_id': user_id, 'league_id': league_id };
    this.draftSocket.emit('ang_autodraftfalse', userData);
    return new Observable<any>(autodraftfalseEmitObserver => {
      this.autodraftfalseEmitObserver = autodraftfalseEmitObserver;
    });
  }

  activeDraftEmit(data): Observable<any> {
    this.draftSocket.emit('active_draft', data);
    return new Observable<any>(activeDraftObserver => {
      this.activeDraftObserver = activeDraftObserver;
    });
  }

  emitActiveDraft(data) {
    this.draftSocket.emit('active_draft', data);
  }

  showActiveDraftData(): Observable<any> {
    this.draftSocket.on('show_draft_Status', (res) => {
      this.activeDraftDataObserver.next(res);
    });

    return new Observable<any>(activeDraftDataObserver => {
      this.activeDraftDataObserver = activeDraftDataObserver;
    });
  }

  showDraftStatus(): Observable<any> {
    let localObserver;
    this.draftSocket.on('show_draft_status', res => {
      localObserver.next(res);
    });

    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }

  activeDraftPickChanges(): Observable<any> {
    this.draftSocket.on('pick_changes', (res) => {
      this.activeDraftPickObserver.next(res);
    });

    return new Observable<any>(activeDraftPickObserver => {
      this.activeDraftPickObserver = activeDraftPickObserver;
    });
  }

  pickChanges(): Observable<any> {
    let localObservable;
    this.draftSocket.on('pick_changes', res => {
      localObservable.next(res);
    });

    return new Observable<any>(obs => {
      localObservable = obs;
    });
  }

  lastPickReverse(): Observable<any> {
    let localObservable;
    this.draftSocket.on('Draft last pick reverse msg', res => {
      localObservable.next(res);
    });

    return new Observable<any>(obs => {
      localObservable = obs;
    });
  }

  draftResetCounter(): Observable<any> {
    this.draftSocket.on('draft_restart_counter', (res) => {
      this.draftResetCounterObserver.next(res);
    });

    return new Observable<any>(draftResetCounterObserver => {
      this.draftResetCounterObserver = draftResetCounterObserver;
    });
  }

  draftReset(): Observable<any> {
    let localObserver;
    this.draftSocket.on('draft_restart_counter', res => {
      localObserver.next(res);
    });

    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }

  restart_msg(): Observable<any> {
    this.draftSocket.on('restart_msg', (res) => {
      this.restart_msgObserver.next(res);
    });

    return new Observable<any>(restart_msgObserver => {
      this.restart_msgObserver = restart_msgObserver;
    });
  }

  updateLeagueMember(): Observable<any> {
    this.draftSocket.on('update_league_member', (res) => {
      this.updateLeagueMemberObserver.next(res);
    });

    return new Observable<any>(updateLeagueMemberObserver => {
      this.updateLeagueMemberObserver = updateLeagueMemberObserver;
    });
  }

  updateTournamentMember(): Observable<any> {
    this.draftSocket.on('update_tournament_member', (res) => {
      this.updateTournamentMemberObserver.next(res);
    });

    return new Observable<any>(updateTournamentMemberObserver => {
      this.updateTournamentMemberObserver = updateTournamentMemberObserver;
    });
  }

  draftButtonEmit(data): Observable<any> {
    this.draftSocket.emit('pick player', data);
    return new Observable<any>(draftButtonObserver => {
      this.draftButtonObserver = draftButtonObserver;
    });
  }

  saveDraftRankEmit(data): Observable<any> {
    this.draftSocket.emit('save_draft_rank', data);
    return new Observable<any>(saveDraftRankObserver => {
      this.saveDraftRankObserver = saveDraftRankObserver;
    });
  }

  messageLeaguePost() {
    this.draftSocket.on('league post', (res) => {
      this.messageObserver.next(res);
    });

    return new Observable<any>(messageObserver => {
      this.messageObserver = messageObserver;
    });
  }

  leaguePost() {
    let localObservable;
    this.draftSocket.on('league post', res => {
      localObservable.next(res);
    });

    return new Observable<any>(obs => {
      localObservable = obs;
    });
  }

  draftMessage() {
    let localObserver;
    this.draftSocket.on('display draft messages', (res) => {
      localObserver.next(res);
    });

    return new Observable<any>(draftMessageObserver => {
      localObserver = draftMessageObserver;
    });
  }


  draftPausedMessage(): Observable<any> {
    this.draftSocket.on('Draft paused message', (res) => {
      this.draftPauseOrRestart.emit(true);
      this.draftPausedMessageObserver.next(res);
    });

    return new Observable<any>(draftPausedMessageObserver => {
      this.draftPausedMessageObserver = draftPausedMessageObserver;
    });
  }

  pausedMessage(): Observable<any> {
    let localObserver;
    this.draftSocket.on('Draft paused message', res => {
      localObserver.next(res);
    });
    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }

  draftResumeMessage(): Observable<any> {
    this.draftSocket.on('Draft resume message', (res) => {
      this.draftPauseOrRestart.emit(true);
      this.draftResumeMessageObserver.next(res);
    });

    return new Observable<any>(draftResumeMessageObserver => {
      this.draftResumeMessageObserver = draftResumeMessageObserver;
    });
  }

  resumeMessage(): Observable<any> {
    let localObserver;
    this.draftSocket.on('Draft resume message', res => {
      localObserver.next(res);
    });
    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }

  activePickChanges() {
    this.draftSocket.on('active_pick_changes', (res) => {
      this.activePickChangesObserver.next(res);
    });

    return new Observable<any>(activePickChangesObserver => {
      this.activePickChangesObserver = activePickChangesObserver;
    });
  }

  getNewActiveLeague() {
    let localObserver;
    this.draftSocket.on('active_pick_changes', res => {
      localObserver.next(res);
    });

    return new Observable<any>(response => {
      localObserver = response;
    });
  }

  updatePaymentSatus(): Observable<any> {
    let localObserver;
    this.draftSocket.on('deposit_status', res => {
      localObserver.next(res);
    });

    return new Observable<any>(obs => {
      localObserver = obs;
    });
  }

  draftActiveEmit(league_id, player_id): Observable<any> {
    const data = { 'league_id': league_id, 'player_id': player_id };
    this.draftSocket.emit('draft_active', data);
    return new Observable<any>(draftActiveReqObserver => {
      this.draftActiveReqObserver = draftActiveReqObserver;
    });
  }

  sendDraftActive(league_id, player_id, position) {
    this.draftSocket.emit('draft_active_app', {
      league_id,
      player_id,
      position
    });
  }

  draftActiveOn(): Observable<any> {
    let observer;
    this.draftSocket.on('draft_active', (res) => {
      observer.next(res);
    });
    return new Observable<any>(draftActiveOnObserver => {
      observer = draftActiveOnObserver;
    });
  }

  /* header chat emit and listen socket */
  getMessagesEmit(userID, chat_cursor, type = ''): Observable<any> {
    var data = { 'userID': userID, 'chat_cursor': chat_cursor, 'dropdown': type, 'is_app': 'No' };
    this.chatSocket.emit('get messages', data);
    return new Observable<any>(getMessagesObserver => {
      this.getMessagesObserver = getMessagesObserver;
    });
  }

  displayMessages(): Observable<any> {
    this.chatSocket.on('disply messages', (res) => {
      this.displayMessagesObserver.next(res);
    });
    return new Observable<any>(displayMessagesObserver => {
      this.displayMessagesObserver = displayMessagesObserver;
    });
  }
  
  showMessages(): Observable<any> {
    this.chatSocket.on('disply messages', (res) => {
      this.showMessagesObserver.next(res);
    });
    return new Observable<any>(showMessagesObserver => {
      this.showMessagesObserver = showMessagesObserver;
    });
  }

  receiveMessage(): Observable<any> {
    this.chatSocket.on('receive message', (res) => {
      this.receiveMessageObserver.next(res);
    });
    return new Observable<any>(receiveMessageObserver => {
      this.receiveMessageObserver = receiveMessageObserver;
    });
  }
  
  newMessage(): Observable<any> {
    return new Observable<any>(observer => {
      this.draftSocket.on('new message', (res) => {
        observer.next(res);
      });
    });
  }

  friendInviteNoti(): Observable<any> {
    this.chatSocket.on('friend invite notification', (res) => {
      this.friendInviteNotiObserver.next(res);
    });
    return new Observable<any>(friendInviteNotiObserver => {
      this.friendInviteNotiObserver = friendInviteNotiObserver;
    });
  }

  friendMsgInviteNoti(): Observable<any> {
    this.chatSocket.on('friend msg notification', (res) => {
      this.friendMsgInviteNotiObserver.next(res);
    });
    return new Observable<any>(friendMsgInviteNotiObserver => {
      this.friendMsgInviteNotiObserver = friendMsgInviteNotiObserver;
    });
  }

  updateReqCount(userID, counter): Observable<any> {
    var data = { 'userID': userID, 'counter': counter };
    this.chatSocket.emit('update_req_count', data);
    return new Observable<any>(updateReqCountObserver => {
      this.updateReqCountObserver = updateReqCountObserver;
    });
  }

  addActiveUser(data): Observable<any> {
    this.chatSocket.emit('add_active_user', data);
    return new Observable<any>(addActiveUserObserver => {
      this.addActiveUserObserver = addActiveUserObserver;
    });
  }

  getNotification(user_id, noti_cursor): Observable<any> {
    var data = { 'userID': user_id, 'noti_cursor': noti_cursor, 'is_app': 'no' };
    this.chatSocket.emit('get notification', data);
    return new Observable<any>(getNotificationObserver => {
      this.getNotificationObserver = getNotificationObserver;
    });
  }

  displyNotifications(): Observable<any> {
    this.chatSocket.on('disply notifications', (res) => {
      this.displyNotificationsObserver.next(res);
    });
    return new Observable<any>(displyNotificationsObserver => {
      this.displyNotificationsObserver = displyNotificationsObserver;
    });
  }

  userTyping(data) {
    this.chatSocket.emit("userTyping", data);
  }
 
  getContacts(data) {
    this.chatSocket.emit("get contacts", data);
  }

  getIndidualChat(data) {
    this.chatSocket.emit("get_indidual_chat", data);
  }

  post_message(data) {
    this.chatSocket.emit("post_messages", data);
  }
  
  send_message(data) {
    this.chatSocket.emit("send message", data);
  }

  readMsgCount(data) {
    this.chatSocket.emit("read_msg_count", data);
  }

  updateMessageReceived(data) {
    this.chatSocket.emit("update message received", data);
  }


  displyContacts(): Observable<any> {
    this.chatSocket.on('disply contacts', (res) => {
      this.displyContactsObserver.next(res);
    });
    return new Observable<any>(displyContactsObserver => {
      this.displyContactsObserver = displyContactsObserver;
    });
  }

  priorChat(): Observable<any> {
    this.chatSocket.on('prior_chat', (res) => {
      this.priorChatObserver.next(res);
    });
    return new Observable<any>(priorChatObserver => {
      this.priorChatObserver = priorChatObserver;
    });
  }

  receiveUserTyping(): Observable<any> {
    this.draftSocket.on('receiveUserTyping', (res) => {
      this.receiveUserTypingObserver.next(res);
    });
    return new Observable<any>(receiveUserTypingObserver => {
      this.receiveUserTypingObserver = receiveUserTypingObserver;
    });
  }

  deactiveUser(): Observable<any> {
    this.draftSocket.on('deactive_user', (res) => {
      this.deactiveUserObserver.next(res);
    });
    return new Observable<any>(deactiveUserObserver => {
      this.deactiveUserObserver = deactiveUserObserver;
    });
  }

  receiveActiveUser(): Observable<any> {
    this.draftSocket.on('receive_active_user', (res) => {
      this.receiveActiveUserObserver.next(res);
    });
    return new Observable<any>(receiveActiveUserObserver => {
      this.receiveActiveUserObserver = receiveActiveUserObserver;
    });
  }

  receiveNewChatUser(): Observable<any> {
    this.draftSocket.on('receive_new_chat_user', (res) => {
      this.receiveNewChatUserObserver.next(res);
    });
    return new Observable<any>(receiveNewChatUserObserver => {
      this.receiveNewChatUserObserver = receiveNewChatUserObserver;
    });
  }

  playSound() {
    const sound = new Howl({    
      src: [`/${environment.ANGULAR_FOLDER_NMAE}`+'/assets/media/cool-notifications.mp3'],
      autoplay: true,
      loop: false,
      volume: 1.0,
      onend: function () {
      }
    });
  }

  getByeWeeks(game_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/teams/byeWeeks/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + game_id);
  }

  getInfoTabs(tour_id, league_id, user_id, tab) {
    let url;
    if (tour_id > 0) {
      url = `${environment.phpApiUrl}` + '/tournament/infoBox/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + tour_id + '/' + league_id + '/' + user_id + '/' + tab;
    } else {
      url = `${environment.phpApiUrl}` + '/fantasyLeague/infoBox/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + league_id + '/' + user_id + '/' + tab;
    }
    return this._utilsService.getRequest(url);
  }

  getInfobox(player_id, season_id, league_id, abbr, tab,simple='N', cache = false) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/player/player-info-app-expand/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + player_id + '/' + season_id + '/' + league_id + '/' + abbr + '/' + tab+'?simple='+simple+'&cache='+cache);
  }

  getDraftChat(league_id, filter_type, page) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user_posts/get-draft-league-post/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + league_id + '/' + filter_type + '/' + page);
  }

  getActiveSeason(game_id) {
    return this._utilsService.getRequest(`${environment.boxScoreUrl}/activeSeason/${game_id}`);
  }

  createObservable(): Observable<number> {
    return new Observable<number>(observer => {
      this.observer = observer;
    });
  }

  createAnyObservable(): Observable<any> {
    return new Observable<any>(draftObserver => {
      this.draftObserver = draftObserver;
    });
  }

  createDraftObservable(): Observable<any> {
    return new Observable<any>(observer => {
      this.observer = observer;
    });
  }

  createPickerTimeObservable(): Observable<any> {
    return new Observable<any>(pickerTimeObserver => {
      this.pickerTimeObserver = pickerTimeObserver;
    });
  }

  createinitDataObservable(): Observable<any> {
    return new Observable<any>(initDataObserver => {
      this.initDataObserver = initDataObserver;
    });
  }

  public manageCounter() {

    this.socket.emit('clientdata', {
      msg: 'Yes, its working for me!!'
    });

  }
  
  messageReceiveEmit(data) {
    this.newMsgReceive.emit(data);
  }
  
  activeDraftVisibleEmit(isVisible) {
    this.activeDraftVisible.emit(isVisible);
  }

  private handleError(error) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return Observable.throw(errMessage);
    }
    return Observable.throw(error || 'Socket.io server error');
  }
  
  userChatTyping(data) {
    this.chatSocket.emit("userChatTyping", data);
  }

  getOnlineContact(data){
    this.chatSocket.emit("getOnlineContact", data);
  }

  receiveUserChatTyping(): Observable<any> {
    return new Observable<any>(observer => {
      this.draftSocket.on('receive user chat typing', (res) => {
        observer.next(res);
      });
    });
  }

  receiveOnlineContact(): Observable<any> {
    return new Observable<any>(observer => {
      this.draftSocket.on('receive online contact', (res) => {
        observer.next(res);
      });
    });
  }
}